import type { DeviceCalendarEventProps } from "@/utils/calendar.util";

// on web, AddToCalendar functionality is not supported at this time
const AddToCalendar = (_props: {
  event: DeviceCalendarEventProps;
  eventExternalId: string;
  isGroupClassEvent: boolean;
}) => null;

export { AddToCalendar };
